import { faTimesCircle, faWindowClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { withTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';
import './index.css';

const cookies = new Cookies();

class CookieConsent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: !cookies.get('cookie_consent'),
      // True while a category deck is loading — hides this banner on mobile
      // until the deck is revealed (see Category.js `emitDeckLoading`).
      deckLoading: false,
    };
    this.handleClose = this.handleClose.bind(this);
    this.onDeckLoading = this.onDeckLoading.bind(this);
  }

  componentDidMount() {
    window.addEventListener('afnu:deck-loading', this.onDeckLoading);
    // The category deck mounts before this global banner, so its first
    // "loading" event is missed — sync the initial state from the live spinner.
    if (document.querySelector('.preloader.show-item')) {
      this.setState({ deckLoading: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('afnu:deck-loading', this.onDeckLoading);
  }

  onDeckLoading(e) {
    this.setState({ deckLoading: !!(e && e.detail && e.detail.loading) });
  }

  handleClose() {
    cookies.set('cookie_consent', '1', {
      path: '/',
      maxAge: 86400 * 120,
    });
    this.setState({ visible: false });
  }

  render() {
    const { t } = this.props;
    if (!this.state.visible) {
      return null;
    }

    // Mobile only (matches this banner's mobile breakpoint): stay hidden while the
    // category deck spinner shows, then fade in once the deck data is revealed.
    const isMobile =
      typeof window !== 'undefined' && window.matchMedia('(max-width: 480px)').matches;
    const hiddenForLoading = isMobile && this.state.deckLoading;

    return (
      <div className={'cookie-consent-banner' + (hiddenForLoading ? ' cc-loading-hidden' : '')}>
        <div className="cookie-consent-content">
          <span className="cookie-consent-text">
            {t('cookieConsent.message')}
            <a href="/privacy.html" className="cookie-consent-link">
              {t('cookieConsent.privacyLink')}
            </a>{' '}
            {t('cookieConsent.privacyLinkSuffix')}
          </span>
        </div>
        <button
          className="cookie-consent-close"
          onClick={this.handleClose}
          aria-label={t('common.buttons.close')}
        >
          <FontAwesomeIcon icon={faWindowClose} />
        </button>
      </div>
    );
  }
}

export default withTranslation()(CookieConsent);
